import { AxiosRequestConfig } from 'axios';
import axios, { ErrorMessage2 } from '../../../api';
import { endpoints } from '../../../config';
import { errors } from 'helpers/errors';

export type ApiReturn2<T = any> = {
  response: T | null;
  errors: ErrorMessage2[] | null;
  id?: number;
};

const getCandidateDetailsUrl = endpoints.candidateSignUp.getCandidateDetails;

export const getCandidateDetailsApi = async (): Promise<ApiReturn2> => {
  try {
    const config: AxiosRequestConfig = {
      params: {},
    };
    const res = await axios.get(getCandidateDetailsUrl, config);
    if (res.data.status === '1') {
      return {
        response: res.data.details,
        errors: null,
      };
    } else {
      return {
        response: res.data.details,
        errors: res.data.errors,
      };
    }
  } catch (error) {
    const importedErrors = errors;

    return {
      response: null,
      errors: [
        {
          errorType: 'BadRequest',
          fieldName: 'Generic',
          messageCode:
            importedErrors && importedErrors.generic
              ? importedErrors.generic
              : 'There was an error, please try again later.',
        },
      ],
    };
  }
};
